var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm0 3C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.448 10.816c-.033.014-.11.108-.229.279-.12.172-.247.36-.382.563-.134.204.35-.293.305-.241-.092.113-.002-.177-.803.705-.8.882-1.046 1.431-1.325 1.778-.155.183-.065.142-.562.73-.497.588-.302.204-.487.423-.15.185-.356.452-.62.802a23.32 23.32 0 0 1-.686.875c-.106.038-.3.224-.583.56-.283.335-.516.63-.697.886-.04.056-.073.11-.104.164a1.169 1.169 0 0 1-.078-.074c-.103-.103-1.012-.76-1.226-.977-.029-.11-.196-.322-.501-.637a13.501 13.501 0 0 0-.812-.777c-.235-.204-.446-.307-.632-.31-.448.018-.769.1-.964.245C9.866 15.955 9 16.939 9 17.18c.122.125.267.277.435.455.13.139.245.256.353.363.31.333.641.673 1.013 1.028.486.465.802.874 1.135 1.234.17.206 1.314 1.366 1.819 1.739.58-.075.77-.072 1.132-.336.145-.106 1.017-1.006 1.093-1.116a.808.808 0 0 0 .218-.165c.126-.143.231-.27.327-.389.3-.34.608-.704.927-1.11.416-.531.787-.98 1.112-1.347.188-.19.076.018 1.57-1.804.301-.39.594-.573 1.018-1.074.424-.5.985-.986 1.311-1.53.01-.405-.895-1.573-1.178-1.924-.283-.351-.563-.48-.837-.39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertTick);
export default __webpack_public_path__ + "static/media/icon_alert_tick.681f2f8d058142e5e2796c71948a75c3.svg";
export { ForwardRef as ReactComponent };